import design from "./design";
import normal from "./normal";
import personality from "./personality";
import cross from "./cross";

export default {
    design, normal, personality, cross
}